import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import initDevConsoleLogger from './utils/devConsoleLogger';

initDevConsoleLogger();

if ( process.env.REACT_APP_IS_PRODUCTION ) {
  Sentry.init({
    dsn: 'https://0de841b706854fa48b5eaab6244cce3f@o659691.ingest.sentry.io/5764098',
    integrations: [Sentry.browserTracingIntegration()],
    environment: process.env.NODE_ENV,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: process.env.REACT_APP_NODE_ENV === 'development' ? 1 : 0.3,
  });
}

ReactDOM.render(<BrowserRouter><App /></BrowserRouter>, document.getElementById('app-root'));

// react-scripts 5 builds no service-worker.js, so register() only ever fetched
// the SPA fallback HTML. A worker installed by a react-scripts 3 build (before
// 2022-08) can't update off that and keeps serving its cached bundle (#2075),
// so remove any registration this page is running under.
serviceWorker.unregister();
